import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tenge",
  "use": "icon-tenge-usage",
  "viewBox": "0 0 13 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 17\" id=\"icon-tenge\"><path d=\"M12.765 1.805V0H.947v1.805zm0 1.687H.947v1.805h4.905v11.735h1.996V5.297h4.917z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol